'use client'

import * as React from 'react'
import { AppleWhiteIcon, FacebookWhiteIcon, GoogleFasIcon } from 'primitives/icons/social'
import { useTranslations } from 'next-intl'
import invariant from 'tiny-invariant'
import { tw } from 'utils/classnames'
import { getLastUsedMethod, saveLastUsedMethod } from './utils/track-registration'
import { LastUsedMarker } from './last-used-marker'

const CF_URL = process.env.NEXT_PUBLIC_CF_URL || process.env.VITE_CF_URL

invariant(CF_URL, 'NEXT_PUBLIC_CF_URL inside SocialButtons is required')

const SOCIAL_BUTTONS = [
  {
    name: 'google',
    icon: GoogleFasIcon,
    color: 'bg-[#ff4554]',
  },
  {
    name: 'facebook',
    icon: FacebookWhiteIcon,
    color: 'bg-[#3b5898]',
  },
  {
    name: 'apple',
    icon: AppleWhiteIcon,
    color: 'bg-[#000000]',
  },
]

export function SocialButtons({ modalType }: { modalType: 'login' | 'register' }) {
  const t = useTranslations('social')
  const [lastUsedMethod] = React.useState(getLastUsedMethod())

  // oxlint-disable-next-line no-negated-condition
  const href = typeof window !== 'undefined' ? window.location.href : ''

  const returnUrl = encodeURIComponent(href)

  const apiUrl = `${CF_URL}/wc-api/`

  return (
    <div className="flex w-full flex-col gap-[10px]">
      {SOCIAL_BUTTONS.map(button => {
        const buttonStyle =
          'text-[#ffffff] hover:opacity-80 text-14 relative flex h-[45px] w-full items-center justify-center gap-[10px] rounded px-5 uppercase'

        return (
          <a
            key={`social_button-${button.name}`}
            rel="noreferrer"
            href={`${apiUrl}?wc-api=auth&start=${button.name}&return=${returnUrl}`}
            className={tw(button.color, buttonStyle)}
            onClick={() => {
              saveLastUsedMethod(button.name)
            }}
          >
            <button.icon className="h-[20px] w-[20px]" />
            {t(button.name)}

            {lastUsedMethod === button.name ? <LastUsedMarker /> : null}
          </a>
        )
      })}
    </div>
  )
}
